<template>
    <div>
        <div class="row roots">
            <app-sub />
            <app-card />
        </div>
        <app-invoice />
    </div>
</template>

<script>
import sub from '../components/sub.vue'
import card from '../components/card.vue'
import invoice from '../components/invoice.vue'

export default {
    components: {
        appSub: sub,
        appCard: card,
        appInvoice: invoice,
    },
}
</script>

<style scoped>
.roots {
    margin: 1rem 0;
}
</style>
